import { API_CONFIG } from '../../../config/api';
import { authService } from '../../../services/authService';


export interface GeneratedDownload {
    token: string;
    url: string;
    expiraEm: string;
    totalArquivos: number;
    tamanhoBytes: number;
}


export interface DownloadItem {
    token: string;
    idUsuario: number;
    nomeArquivo: string;
    nomesOriginais: string;
    tamanhoBytes: number;
    ativo: boolean;
    createdAt: string;
    expiraEm: string;
}

export class DocumentosService {
    private baseUrl: string;

    constructor() {
        this.baseUrl = `${API_CONFIG.BASE_URL_JAVA}/api/v1`;
    }
    async uploadArquivos(files: File[]): Promise<GeneratedDownload> {
        const idUsuario = localStorage.getItem('id_usuario');
        if (!idUsuario) {
            throw new Error('Usuário não identificado. Faça login novamente.');
        }

        const token = await authService.getValidToken();

        const formData = new FormData();
        files.forEach(file => formData.append('arquivos', file));

        const url = `${this.baseUrl}/links-download?idUsuario=${encodeURIComponent(idUsuario)}`;

        const response = await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: formData,
        });

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(errorText || `Erro ao enviar arquivos: ${response.statusText}`);
        }

        return await response.json();
    }

    async listarArquivos(): Promise<DownloadItem[]> {
        const idUsuario = localStorage.getItem('id_usuario');
        if (!idUsuario) {
            throw new Error('Usuário não identificado. Faça login novamente.');
        }

        const token = await authService.getValidToken();
        const url = `${this.baseUrl}/links-download?idUsuario=${encodeURIComponent(idUsuario)}`;

        const response = await fetch(url, {
            method: 'GET',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erro ao listar arquivos: ${response.statusText}`);
        }

        const data = await response.json();
        return Array.isArray(data) ? data : [];
    }

    getPublicUrl(token: string): string {
        return `${this.baseUrl}/downloads/${token}`;
    }
}

export const documentosService = new DocumentosService();
